module.exports = __webpack_public_path__ + "media/images/icons/hamburger_menu-4ecb46829184784a3a6c2155fafb85f2.svg";